import Image from "next/image"
import { Anchor } from "../app/components/anchor"
import { TRUSTPILOT_REVIEWS_URL, GOOGLE_MAPS_URL } from "../constants/brand"
import StarRating from "./StarRating"
import { useReviewsContext } from "../context/ReviewsContext"

type TrustpilotGoogleReviewsProps = {
  className?: string
  variant?: "both" | "trustpilot" | "google"
}

export default function TrustpilotGoogleReviews({
  className,
  variant = "both",
}: TrustpilotGoogleReviewsProps) {
  const { blokReviews } = useReviewsContext()
  return (
    <div className={"flex justify-center items-center gap-4 " + className}>
      {(variant === "both" || variant === "google") && (
        <section className="w-fit px-4 md:px-8 py-4 rounded-2xl shadow-md bg-white">
          <Image
            className="mb-5 h-8 w-auto"
            src="/icons/google.svg"
            alt="google logo"
            width={100}
            height={20}
          />
          <p className="text-sm mb-2">Average Rating</p>
          <div className="w-full flex flex-col sm:flex-row text-2xl sm:items-center">
            {blokReviews?.googleRatings}
            <StarRating value={5} className="sm:ml-2" />
          </div>
          <Anchor
            className="mt-2"
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noreferrer"
            dofollow
            passHref
          >
            {blokReviews?.googleReviews} reviews
          </Anchor>
        </section>
      )}
      {(variant === "both" || variant === "trustpilot") && (
        <section className="w-fit px-4 md:px-8 py-4 rounded-2xl shadow-md bg-white">
          <Image
            className="mb-5 h-8 w-auto"
            src="/icons/trust-pilot.svg"
            alt="trust pilot logo"
            width={100}
            height={20}
          />
          <p className="text-sm mb-2">Average Rating</p>
          <div className="w-full flex flex-col sm:flex-row text-2xl sm:items-center">
            {blokReviews?.trustpilotRatings}
            <StarRating value={5} className="sm:ml-2" />
          </div>
          <Anchor
            className="mt-2"
            href={TRUSTPILOT_REVIEWS_URL}
            target="_blank"
            dofollow
            passHref
          >
            {blokReviews?.trustpilotReviews} reviews
          </Anchor>
        </section>
      )}
    </div>
  )
}
